// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RFfGTgjAr1Yi60 {
  padding: 10px 12px 10px 8px;
  top: 0;
  right: 0;
  z-index: 2;
  position: absolute;
}
.RFfGTgjAr1Yi60:hover {
  filter: brightness(75%);
}
.FSNVMjwRhsUdPP {
  padding: 10px 8px 10px 12px;
  top: 0;
  left: 0;
  z-index: 2;
  position: absolute;
}
.FSNVMjwRhsUdPP:hover {
  filter: brightness(75%);
}
.jff15rhakwA0aM {
  box-sizing: border-box;
  color: var(--ds-text-subtle, #44546f);
  display: block;
  line-height: 40px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
  margin: 0 0 6px 0;
  overflow: hidden;
  padding: 0 32px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `RFfGTgjAr1Yi60`,
	"backButton": `FSNVMjwRhsUdPP`,
	"title": `jff15rhakwA0aM`
};
export default ___CSS_LOADER_EXPORT___;
